import { authHeader, handleResponse } from '../helpers';
export const WarrantyRptService = {
    fetchWarrantyData   
};

function fetchWarrantyData(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data)
    };

    return fetch(`${process.env.REACT_APP_API_URL}Reports/GetWarrantyReport`, requestOptions)
        .then(handleResponse);
}